export default "__VITE_ASSET__DBvQ5Sr3__"